import React, { Component } from 'react';
import { Layout, Card, Spin } from 'antd';
import { withAsyncActions } from 'react-async-client';
import moment from 'moment';
import { project_show, project_application, profile } from 'constants/routes';
import { Link } from 'react-router-dom';

import { getNotifications, markNotifications } from 'actions/asyncActions';
import RouteTitle from 'components/pages/RouteTitle.js';
import Breakpoint from 'components/layout/Breakpoint.js';

function NoticeCard(props) {
    const {date, children, read} = props;
    return (
        <Card className={`${read ? '' : 'mark_notice'} card-notice`}>
            {date && (
                <div className="card-notice-date">{moment(date).format(`HH:mm  DD.MM.YYYY`)}</div>
            )}
            <div className="card-notice-text">{children}</div>
        </Card>
    );
}

@withAsyncActions({
    getNotifications,
    markNotifications
})
export default class Notifications extends Component {
    componentDidMount() {
        this.props.getNotifications.dispatch();
    }

    componentDidUpdate(props) {
        const {success: psuccess = false} = props.getNotifications.meta;
        const {success = false} = this.props.getNotifications.meta;
        if (psuccess !== success && success) {
            this.props.markNotifications.dispatch();
        }
    }

    renderNotice() {
        const {data} = this.props.getNotifications;
        return data.map((notice) => {
            switch (notice.type) {
                case "new_specification": {
                    return (
                        <NoticeCard date={notice.created_at} key={notice.id} read={Boolean(notice.read)}>
                            Получена новая <Link to={project_application.stringify({project_id: notice.project_id, id: notice.application_id})}>спецификация</Link>
                        </NoticeCard>
                    );
                }
                case "registration": {
                    return (
                        <NoticeCard date={notice.created_at} key={notice.id} read={Boolean(notice.read)}>
                            Поздравляем! Вы зарегистрировались
                        </NoticeCard>
                    );
                }
                case "new_project": {
                    return (
                        <NoticeCard date={notice.created_at} key={notice.id} read={Boolean(notice.read)}>
                            Создан новый <Link to={project_show.stringify({id: notice.project_id})}>проект</Link>
                        </NoticeCard>
                    );
                }
                case "new_application": {
                    return (
                        <NoticeCard date={notice.created_at} key={notice.id} read={Boolean(notice.read)}>
                            Создана новая <Link to={project_application.stringify({project_id: notice.project_id, id: notice.application_id})}>заявка</Link>
                        </NoticeCard>
                    );
                }
                case "new_offer": {
                    return (
                        <NoticeCard date={notice.created_at} key={notice.id} read={Boolean(notice.read)}>
                            Получено новое <Link to={project_application.stringify({project_id: notice.project_id, id: notice.application_id})}>коммерческое предложение</Link>
                        </NoticeCard>
                    );
                }
                case "new_message": {
                    return (
                        <NoticeCard date={notice.created_at} key={notice.id} read={Boolean(notice.read)}>
                            Получено новое сообщение
                            {' '}в проекте {notice.project_name}, заявке <Link to={project_application.stringify({project_id: notice.project_id, id: notice.application_id})}>{notice.app_name}</Link>
                        </NoticeCard>
                    );
                }
                case "billing_info": {
                    return (
                        <NoticeCard date={notice.created_at} key={notice.id} read={Boolean(notice.read)}>
                            Пожалуйста, заполните ваши <Link to={profile.stringify()}>платежные данные</Link>
                        </NoticeCard>
                    );
                }
                default:
                    return null;
            }
        });
    }

    render() {
        const {meta, data} = this.props.getNotifications;
        return (
            <Layout className="container page sm-720 md-970 main-content">
                {meta.pending &&  <Spin style={{ transform: "translateY(150px)" }}/>}

                <Breakpoint min="lg">
                    <RouteTitle className="title-route title-page" />
                </Breakpoint>
                <Breakpoint min="sm">
                    {meta.success && (!data || !data.length) && (
                        <Card className="table-card">Нет данных</Card>
                    )}
                    {meta.success && data && data.length > 0 && (
                        this.renderNotice()
                    )}
                </Breakpoint>
                <Breakpoint max="sm">
                    {meta.success && (!data || !data.length) && (
                        <Card className="table-card">Нет данных</Card>
                    )}
                    {meta.success && data && data.length > 0 && (
                        this.renderNotice()
                    )}
                </Breakpoint>
            </Layout>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/notifications/Notifications.js